import { SVGProps, memo } from 'react';

function UnassignedDevicesIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path d="M16.6733 32.628H21.6827" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M28.3621 22.2916V32.628C28.3621 34.4725 26.8669 35.9675 25.0225 35.9675H13.3336C11.4894 35.9675 9.99414 34.4725 9.99414 32.628V7.58072C9.99414 5.73611 11.4894 4.24086 13.3336 4.24086H28.3621V7.28951"
        stroke="black"
        strokeLinecap="round"
      />
      <path d="M31.3251 12.0244L25.6939 17.5567" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M25.7434 11.9749L31.2757 17.6061" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3381 22.2949C32.4826 22.2949 35.8425 18.9352 35.8425 14.7905C35.8425 10.646 32.4826 7.2861 28.3381 7.2861C24.1934 7.2861 20.8335 10.646 20.8335 14.7905C20.8335 18.9352 24.1934 22.2949 28.3381 22.2949Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default memo(UnassignedDevicesIcon);
